import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/Home.css";

/**
 * Props:
 *   open        – boolean, controlled từ parent
 *   onClose     – fn đóng sidebar
 *   extraMenuGroups – JSX thêm vào giữa
 */
export default function DashboardSidebar({ open, onClose, extraMenuGroups }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Đóng khi navigate
  useEffect(() => { onClose?.(); }, [location.pathname]);

  // Đóng khi resize lên desktop
  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 768) onClose?.(); };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [onClose]);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Overlay */}
      <div
        className={`sidebar-overlay ${open ? "visible" : ""}`}
        onClick={onClose}
      />

      {/* Sidebar */}
      <aside className={`dashboard-sidebar ${open ? "open" : ""}`}>
        <div className="sidebar-brand" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
          <img
            src="https://media4.giphy.com/media/CFaGnXWf6GABHKKZcC/giphy.gif"
            alt="Logo"
            className="sidebar-logo"
          />
          <span className="brand-name-sidebar">K<span className="gold">GAMES</span></span>
        </div>

        <nav className="sidebar-menu">
          <div className="menu-group">
            <span className="menu-label">MENU CHÍNH</span>
            <button className={`menu-item ${isActive("/home") ? "active" : ""}`} onClick={() => navigate("/home")}>
              <span className="menu-icon">🏠</span> Sảnh Game
            </button>
            <button className={`menu-item ${isActive("/leaderboard") ? "active" : ""}`} onClick={() => navigate("/leaderboard")}>
              <span className="menu-icon">🏆</span> Bảng Xếp Hạng
            </button>
          </div>

          {/* Nhóm GIAO DỊCH — Home truyền vào với handler mở modal,
              các trang khác truyền vào với navigate về Home */}
          {extraMenuGroups}

          <div className="menu-group">
            <span className="menu-label">CÁ NHÂN</span>
            <button className={`menu-item ${isActive("/profile") ? "active" : ""}`} onClick={() => navigate("/profile")}>
              <span className="menu-icon">👤</span> Hồ Sơ
            </button>
            <button className={`menu-item ${isActive("/history") ? "active" : ""}`} onClick={() => navigate("/history")}>
              <span className="menu-icon">📜</span> Lịch Sử Cược
            </button>
          </div>

          <div className="menu-group">
            <span className="menu-label">BẢO MẬT</span>
            <button className={`menu-item ${isActive("/security/dashboard") ? "active" : ""}`} onClick={() => navigate("/security/dashboard")}>
              <span className="menu-icon">🛡️</span> Security Dashboard
            </button>
            <button className={`menu-item ${isActive("/blockchain/explorer") ? "active" : ""}`} onClick={() => navigate("/blockchain/explorer")}>
              <span className="menu-icon">🔗</span> Blockchain Explorer
            </button>
          </div>
        </nav>
      </aside>
    </>
  );
}
